import { render } from "./Message.vue?vue&type=template&id=ce643902"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"

import "./Message.vue?vue&type=style&index=0&id=ce643902&lang=scss"
script.render = render

export default script